import 'react-h5-audio-player/lib/styles.css';
import { useNavigate, useParams } from 'react-router-dom';

import { UploadContentLayout } from '@/layout';
import { Music } from '@/pages/Event/components/Music';

export const UploadContentMusic = () => {
  const { eventId } = useParams();
  const navigate = useNavigate();

  return (
    <UploadContentLayout goBack={() => navigate(`/events/${eventId}/upload-content/requests`)}>
      <Music />
    </UploadContentLayout>
  );
};
